<template>
      <transition name = "fade">
    <div class="yujiazai bg" v-show="yujiazaicss" >
      <img class="bg" :src="resourcepath+'/images/1/p1_bg.jpg?v=21'" />
      <img class="p1_1jiazai" :src="resourcepath+'/images/1/p1_1.png?v=12'" />
        <div class="jindubgcontainer">
            <div class="bg" :style="'width:'+jindu+'%;background:#FFF'"></div>
        </div>
    </div>
    </transition>

    
</template>
<script>
import { mapState} from 'vuex'
import  {resourcepath} from '@/commonjs/commonfn.js'
export default {
  name: 'loadui',
  props: ["logofilename", "jindubg"],
  data() {
    return {
      "resourcepath":resourcepath,
    }
  },
  mounted() {},
  methods: {
  
  },
  computed: {
    ...mapState(['suodingtipcss', 'yujiazaicss', 'sharetipcontainercss', 'morentanchuangcss', 'chuangtitle', 'fn', 'jindu', 'starcss', 'isalljiazai','isplaybgmusic']),
  }
}

</script>
<style scoped>
.p1_1jiazai{
    width: 34%;
    position: absolute;
    left: 33%;
    top: 45%;
}
.jindubgcontainer{
    width: 33%;
    height: 2px;
    position: absolute;
    left: 33.1%;
    top: 55%;
 
}
.jindubgcontainer .bg{
    width: 0%;
}
</style>


// WEBPACK FOOTER //
// src/components/loadui.vue